/* eslint-disable */

import React, { Component } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  IconButton,
  Container,
  Card,
  CardContent,
  FormControl,
  OutlinedInput,
  FormHelperText,
  InputLabel,
  InputAdornment,
  Typography,
  Alert,
  Grid,
} from '@mui/material';
import { CheckCircle, Visibility, VisibilityOff } from '@mui/icons-material';
import PasswordStrengthBar from 'react-password-strength-bar';
import AuthServices from '../services/auth';
import localAuthServices from '../localAuthServices';

class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertType: '',
      apiMessage: '',
      valuesOldPassword: '',
      valuesNewPassword1: '',
      valuesNewPassword2: '',
      showOldPassword: false,
      showNewPassword1: false,
      showNewPassword2: false,
      success: false
    };
    this.myRef = React.createRef()
  }

  handleClickShowOldPassword = () => {
    this.setState({
      ...this.state,
      showOldPassword: !this.state.showOldPassword
    })
  };

  handleMouseDownOldPassword = (event) => {
    event.preventDefault();
  };

  handleClickShowNewPassword1 = () => {
    this.setState({
      ...this.state,
      showNewPassword1: !this.state.showNewPassword1
    })
  };

  handleMouseDownNewPassword1 = (event) => {
    event.preventDefault();
  };

  handleClickShowNewPassword2 = () => {
    this.setState({
      ...this.state,
      showNewPassword2: !this.state.showNewPassword2
    })
  };

  handleMouseDownNewPassword2 = (event) => {
    event.preventDefault();
  };

  checkPassword = () => {
    let _password = document.querySelector('input[name="new_password1"]');
    this.setState({
      ...this.state,
      valuesNewPassword1: _password.value
    })
    let _passwordParent = document.querySelector('div.new_password1_container');
    let _hintLabel = document.querySelectorAll('label')[1];
    let _hintText = document.getElementById('password_regex');
    _hintText.style.display = 'none';
    let _parentClasses = _passwordParent.classList;
    _parentClasses.remove('Mui-error');
    _hintLabel.classList.remove('Mui-error');
    var _passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

    if (_password.value != '') {
      if (_passwordRegex.test(_password.value)) {
        _parentClasses.remove('Mui-error');
        _hintLabel.classList.remove('Mui-error');
        _hintText.style.display = 'none';
        return true;
      } else {
        _parentClasses.add('Mui-error');
        _hintLabel.classList.add('Mui-error');
        _hintText.style.display = 'block';
        return false;
      }
    }
  };

  componentDidMount() {
    this.myRef.current.scrollIntoView({ block: 'center' })
    localAuthServices.refreshTokenOnLoad()
  }

  defaultPasswordScoreWords = 'Too short';
  passwordScoreWords = ['Weak', 'Okay', 'Better', 'Good', 'Strong'];

  render() {

    function PasswordException() {
    }

    PasswordException.prototype = new Error();

    return (
      <>
        <div ref={this.myRef}></div>
        {!this.state.success ?
          <Grid
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
          >
            <Grid item xs={12} md={6} className='logoContainer'
              textAlign="center">
              <img src='/logo_black.png' alt="iCapital" className='logo' />
            </Grid>
            <Grid item xs={11} md={6} className='displayBoxBorder'>
              <Box style={{ width: 'auto' }}>
                {this.state.apiMessage != '' &&
                  <Box mb={3}>
                    <Alert severity={this.state.alertType}>
                      {this.state.apiMessage}
                    </Alert>
                  </Box>
                }
                <Box mb={2}>
                  <Typography
                    variant="h4"
                    align="left"
                  >
                    <b>Change Password</b>
                  </Typography>
                </Box>
                {/* <Box mb={1}>
                      <Typography
                        color="textSecondary"
                        align="center"
                        gutterBottom
                      >
                        {'To change your password, please provide your current and new password.'}
                      </Typography>
                    </Box> */}
                <Container maxWidth="sm">
                  <Formik
                    initialValues={{
                      old_password: '',
                      new_password1: '',
                      new_password2: ''
                    }}
                    validationSchema={Yup.object().shape({
                      old_password: Yup.string().max(50).required('Current password is required'),
                      new_password1: Yup.string().max(50).required('New password is required'),
                      new_password2: Yup.string().required('Confirm password is required').when('new_password1',
                        {
                          is: val => (val && val.length > 0 ? true : false),
                          then: Yup.string().oneOf(
                            [Yup.ref('new_password1')],
                            'Confirm password must be matched with new password'
                          )
                        }
                      )
                    })}
                    onSubmit={async (data) => {
                      try {
                        if (!this.checkPassword()) {
                          throw new PasswordException;
                        }
                        var response = await AuthServices.changePassword(data);
                        let success = response.data.message;
                        this.setState({
                          ...this.state,
                          valuesNewPassword1: '',
                          alertType: 'success',
                          apiMessage: success,
                          success: true
                        })
                        document.getElementsByTagName('form')[0].reset();
                      } catch (e) {
                        let error;
                        if (!(e instanceof PasswordException)) {
                          error = e.response.data.message;
                          this.setState({
                            ...this.state,
                            valuesNewPassword1: '',
                            alertType: 'error',
                            apiMessage: error
                          })
                        }
                      }
                    }}
                  >
                    {({
                      errors,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      isSubmitting,
                      touched
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <FormControl
                          fullWidth
                          margin="normal"
                          variant="outlined"
                        >
                          <InputLabel
                            className={(touched.old_password && errors.old_password) ? "Mui-error" : ""}
                            htmlFor="outlined-adornment-old-password"
                          >
                            {'Your current password'}
                          </InputLabel>
                          <OutlinedInput
                            error={Boolean(touched.old_password && errors.old_password)}
                            id="outlined-adornment-old-password"
                            type={this.state.showOldPassword ? 'text' : 'password'}
                            name="old_password"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={this.handleClickShowOldPassword}
                                  onMouseDown={this.handleMouseDownOldPassword}
                                  edge="end"
                                  size="large">
                                  {this.state.showOldPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            }
                            label={'Your current password'}
                            aria-describedby="old-password-helper-text"
                          />
                          {(touched.old_password && errors.old_password) && <FormHelperText
                            className={(touched.old_password && errors.old_password) ? "Mui-error" : ""}
                            id="old-password-helper-text"
                          >
                            {'Current password is required'}
                          </FormHelperText>}
                        </FormControl>
                        <FormControl
                          fullWidth
                          margin="normal"
                          variant="outlined"
                        >
                          <InputLabel
                            className={(touched.new_password1 && errors.new_password1) ? "Mui-error" : ""}
                            htmlFor="outlined-adornment-new-password1"
                          >
                            {'Your new password'}
                          </InputLabel>
                          <OutlinedInput
                            error={Boolean(touched.new_password1 && errors.new_password1)}
                            id="outlined-adornment-new-password1"
                            type={this.state.showNewPassword1 ? 'text' : 'password'}
                            name="new_password1"
                            className="new_password1_container"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            onKeyUp={this.checkPassword}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={this.handleClickShowNewPassword1}
                                  onMouseDown={this.handleMouseDownNewPassword1}
                                  edge="end"
                                  size="large">
                                  {this.state.showNewPassword1 ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            }
                            label={'Your new password'}
                            aria-describedby="new-password1-helper-text"
                          />
                          <p id="password_regex" className="Mui-error">{'New password should be 8 characters long alphanumeric with UPPERCASE, lowercase and at least one of the following special characters !@#$%^&*'}</p>
                          {(touched.new_password1 && errors.new_password1) && <FormHelperText
                            className={(touched.new_password1 && errors.new_password1) ? "Mui-error" : ""}
                            id="new-password1-helper-text"
                          >
                            {'New password is required'}
                          </FormHelperText>}
                        </FormControl>
                        <PasswordStrengthBar shortScoreWord={this.defaultPasswordScoreWords} scoreWords={this.passwordScoreWords} password={this.state.valuesNewPassword1} />
                        <FormControl
                          fullWidth
                          margin="normal"
                          variant="outlined"
                        >
                          <InputLabel
                            className={(touched.new_password2 && errors.new_password2) ? "Mui-error" : ""}
                            htmlFor="outlined-adornment-new-password2"
                          >
                            {'Confirm password'}
                          </InputLabel>
                          <OutlinedInput
                            error={Boolean(touched.new_password2 && errors.new_password2)}
                            id="outlined-adornment-new-password2"
                            type={this.state.showNewPassword2 ? 'text' : 'password'}
                            name="new_password2"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={this.handleClickShowNewPassword2}
                                  onMouseDown={this.handleMouseDownNewPassword2}
                                  edge="end"
                                  size="large">
                                  {this.state.showNewPassword2 ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            }
                            label={'Confirm password'}
                            aria-describedby="new-password2-helper-text"
                          />
                          {(touched.new_password2 && errors.new_password2) && <FormHelperText
                            className={(touched.new_password2 && errors.new_password2) ? "Mui-error" : ""}
                            id="new-password2-helper-text"
                          >
                            {'Confirm password is required and must be matched with your new password'}
                          </FormHelperText>}
                        </FormControl>
                        <Box my={2}>
                          <Button
                            color="primary"
                            disabled={isSubmitting}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                          >
                            {'Change Password'}
                          </Button>
                        </Box>
                      </form>
                    )}
                  </Formik>
                </Container>
              </Box>
            </Grid>
          </Grid>
          :
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
          >
            <Grid item xs={12} md={3}>
              <Card>
                <CardContent sx={{ textAlign: "center" }}>
                  <img src='/logo.png' alt="iCapital" width="50%" height="auto" />
                  <br />
                  <CheckCircle color='success' sx={{ fontSize: "100px", marginBottom: "30px" }} />
                  <Typography>
                    You have successfully changed your Capital Dynamics account password.
                    <br />
                    This window will close in a few seconds.
                  </Typography>
                  <Box sx={{ display: "none" }}>
                    {setTimeout(function () {
                      window.self.close();
                    }, 3000)}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        }
      </>
    );
  }
}

export default function ChangePassword() {
  return <ChangePasswordForm />
}
